import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg sm:rounded-lg px-6 py-10 bg-white w-9/12" }
const _hoisted_2 = { class: "flex justify-center mb-4" }
const _hoisted_3 = { class: "mb-4 sm:mb-0 items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-11/12" }
const _hoisted_8 = { href: "https://admin-ba.superprati.co/" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PerfilMainView = _resolveComponent("PerfilMainView")!

  return (_openBlock(), _createBlock(_component_PerfilMainView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.logoPilotar,
              alt: "Pilotar"
            }, null, 8, _hoisted_4)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            class: "mt-10",
            src: _ctx.token,
            alt: "Pilotar"
          }, null, 8, _hoisted_6),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "" }, [
            _createElementVNode("h1", { class: "text-lg text-center mt-10" }, " Não é possível acessar essa página para solicitar os serviços de abertura de renach e/ou renovação de cnh e/ou emissão de LADV, pois o tempo expirou. Por gentileza, retorne ao SuperPrático e tente novamente. ")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, [
              _createVNode(_component_Button, {
                color: "custom",
                class: "h-12 text-white mt-5"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Acessar o SuperPrático ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}